import { OMNI_ROOT_ADDRESS } from '@src/constants/urls';
import axios from 'axios';

export default function(request, reject, rootAddress) {
  var service = {};
   /**
   * 获取文章详情
   * @param {string} contentId - 文章ID
   * @returns {Promise<Object>}
   */
  service.getArticleDetail = function({ contentId }) {
    return axios
      .get(OMNI_ROOT_ADDRESS + '/api/omni/v1/openapi/get_detail', {
        params: {
          param: JSON.stringify({
            lang: 'zh-Hans',
            contentId: contentId
          })
        }
      })
      .then(response => {
        if (!response?.data?.data) {
          return Promise.reject(new Error('获取活动详情失败'));
        }
        return response.data.data;
      });
    }

  return service;
}
